import { CLOSE_DROPDOWN, TOGGLE_DROPDOWN } from './types'

export default {
  toggleDropdown({ commit, state }, dropdown) {
    // No two dropdowns can be open at the same time
    if (!state[dropdown].expanded) {
      const dropdownKeys = Object.keys(state)
      dropdownKeys.forEach((dropdownToClose) => {
        if (dropdownToClose !== dropdown) {
          commit(CLOSE_DROPDOWN, dropdownToClose)
        }
      })
    }

    commit(TOGGLE_DROPDOWN, dropdown)
  },

  closeDropdown({ commit }, dropdown) {
    commit(CLOSE_DROPDOWN, dropdown)
  },
}
